export enum DashboardStep {
  NewInquiry = 'New Inquiry',
  AcceptManualOneTermOffer = 'AcceptManualOneTermOffer',
  AcceptManualMultiTermOffer = 'AcceptManualMultiTermOffer',
  AcceptPosAutomatedOffer = 'Accept Pos Automated Offer',
  AcceptHilAutomatedOffer = 'Accept Hil Automated Offer',
  FAQ = 'FAQ',
  NoActiveApplication = 'No Active Application',
  AccountSettings = 'AccountSettings',
  LoanDetails = 'LoanDetails',
  NotFoundContact = 'NotFoundContact',
  BorrowerInformation = 'BorrowerInformation',
  CoBorrowerInformation = 'CoBorrowerInformation',
  FundingInformation = 'FundingInformation',
  HomeOwnership = 'HomeOwnership',
  ContractorWorkOrder = 'ContractorWorkOrder',
  AdditionalInformation = 'AdditionalInformation',
  ContractorInfo = 'ContractorInfo',
  ProsperLoan = 'ProsperLoan',
  ProsperJointTransition = 'ProsperJointTransition',
}
